import { createAction } from 'redux-act';

import * as accountManagers from '../../core/accountManagers';

export const fetchAccountManagers = createAction(
  'get account managers with paging',
);
export const fetchAccountManagersSuccess = createAction(
  'get account managers with paging success',
  (allAccounts) => allAccounts
);
export const fetchAccountManagersFail = createAction(
  'get account managers with paging fail',
  (error) => error
);

export const fetchAllAccountManagers = createAction(
  'get all account managers',
);
export const fetchAllAccountManagersSuccess = createAction(
  'get all account managers success',
  (allAccounts) => allAccounts
);
export const fetchAllAccountManagersFail = createAction(
  'get all account managers fail',
  (error) => error
);

export const addAccountManager = createAction(
  'add new account manager',
);

export const addAccountManagerSuccess = createAction(
  'add new account manager success',
  (allplayables) => allplayables
);

export const addAccountManagerFail = createAction(
  'add new account manager fail',
  (error) => error
);

export const updateAccountManager = createAction(
  'update account manager'
);
export const updateAccountManagerSuccess = createAction(
  'update account manager success'
);
export const updateAccountManagerFail = createAction(
  'update account manager fail',
  (error) => error
);

export const openUpdateAccountManager = createAction(
  'open update account manager modal'
);

export const closeUpdateAccountManager = createAction(
  'close update account manager modal'
);

export const reducer = {
  [fetchAccountManagers]: (state, payload) =>
    accountManagers.fetchAccountManagers(state, payload),
  [fetchAccountManagersSuccess]: (state, payload) =>
    accountManagers.fetchAccountManagersSuccess(state, payload),

  [fetchAllAccountManagersSuccess]: (state, payload) =>
    accountManagers.fetchAllAccountManagersSuccess(state, payload),

  [addAccountManagerSuccess]: (state, payload) =>
    accountManagers.addAccountManagerSuccess(state, payload),
  [addAccountManagerFail]: (state, payload) =>
    accountManagers.addAccountManagerFail(state, payload),

  [updateAccountManagerSuccess]: (state, payload) =>
    accountManagers.updateAccountManagerSuccess(state, payload),
  [updateAccountManagerFail]: (state, payload) =>
    accountManagers.updateAccountManagerFail(state, payload),

  [openUpdateAccountManager]: (state, payload) =>
    accountManagers.openUpdateAccountManager(state, payload),
  [closeUpdateAccountManager]: (state, payload) =>
    accountManagers.closeUpdateAccountManager(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/accountManagers.module.js
 **/